import React from 'react';

import {
  Breadcrumb, BreadcrumbItem, BreadcrumbLink, Text,
} from '@chakra-ui/react';

import { Icon } from 'components';

interface BreadCrumbsProps {
  paths: {
    label: string
    path: string
  }[]
}

export default function BreadcrumbMenu({ paths }: BreadCrumbsProps) {
  const Separator = (
    <Icon
      name="chevron-right"
      family="far"
      color="primary.default"
      size="3xs"
    />
  );

  return (
    <Breadcrumb separator={Separator}>
      {paths.map(({ label, path }) => (
        <BreadcrumbItem key={`breadcrumb-${path}`}>
          <BreadcrumbLink href={path}>
            <Text variant="2xSmallRegular">
              {label}
            </Text>
          </BreadcrumbLink>
        </BreadcrumbItem>
      ))}
    </Breadcrumb>
  );
}
